// src/services/api/warehouses.js
import { apiClient } from './base';

export const createWarehouse = async (warehouseData) => {
  try {
    const response = await apiClient.post('/warehouses', warehouseData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getWarehouses = async (params = {}) => {
  try {
    const response = await apiClient.get('/warehouses', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getWarehouse = async (warehouseId) => {
  try {
    const response = await apiClient.get(`/warehouses/${warehouseId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateWarehouse = async (warehouseId, warehouseData) => {
  try {
    const response = await apiClient.put(`/warehouses/${warehouseId}`, warehouseData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteWarehouse = async (warehouseId) => {
  try {
    const response = await apiClient.delete(`/warehouses/${warehouseId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateWarehouseStatus = async (warehouseId, status) => {
  try {
    const response = await apiClient.patch(`/warehouses/${warehouseId}/status`, { status });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getWarehouseAssignedUsers = async (warehouseId) => {
  const response = await apiClient.get(`/warehouses/${warehouseId}/users`);
  return response.data;
};

export const assignUsersToWarehouse = async (warehouseId, userIds) => {
  const response = await apiClient.post(`/warehouses/${warehouseId}/users`, { userIds });
  return response.data;
};

export const removeWarehouseUser = async (warehouseId, userId) => {
  const response = await apiClient.delete(`/warehouses/${warehouseId}/users/${userId}`);
  return response.data;
};
// Warehouses assigned to the logged-in user + their default: { warehouses, defaultWarehouseId }
export const getMyWarehouses = async () => {
  const response = await apiClient.get('/warehouses/mine');
  return response.data;
};
